let token = "";

export const setToken = (newToken) => {
  token = newToken;
};

export const getToken = () => {
  return token;
};

export const baseURL = {
  API_URL_BASE: "https://internal-api.dev.hav-g.in/",
  // API_URL_BASE: "http://localhost:5001/",
  CRM_BASE_URL: "https://erp.traya.health",
  PREVIEW_URL: {
    FEMALE: "https://traya.health/pages/result-f/",
    MALE: "https://traya.health/pages/result4/",
  },
  FORM_URL: "https://form.dev.hav-g.in/",
  FORMV2S_URL: "https://form.traya.health/",
  CMS_URL: "https://erp.cms.dev.hav-g.in",
};

export const SECURITY_TOKEN = "e2623576-930b-48b6-81e2-a3cb5e37f47d";
export const CLICK_POST_URL = 'https://trayahealth.clickpost.ai/returns';

export const GOOGLE_OAUTH_CLIENT_ID =
  "95993965258-rklc6lesppdcqda08sli02fk4rv3h296.apps.googleusercontent.com";
export const FEEDBACK_FORM = {
  PROD_URL: "https://customerfeedback.traya.health",
  DEV_URL: "https://customerfeedback.dev.hav-g.in",
};
export const USER_PING_CALL = 60000;
export const PUBLIC_VAPID_KEY =
  "BCho54cnMquwR-3qp3lJTZUKf9jFikDTWCa7XXYYAIelmLdsCXRpTGBE2NmH5SadfdwOOzBSSD0yeg2NnoU66JA";

export const CALL_HIPPO_TOKEN = "63f8b28bed9535141b703789";
export const CALL_HIPPO_EMAIL = "agarwalsandip@traya.health";

export const opsTeamMember = {
  "jaiswalneelu@traya.health": {
    // value: "91ce29b3-5e45-4411-b0e0-7c0ef6954599", // prod
    value: "126781d4-e984-461e-92c2-ad5fe06845e6", //dev
    label: "Neelu",
  },
  "ganeshkamble@traya.health": {
    // value: "18ef9561-3d85-4f6e-a166-74bba0df828e", // prod
    value: "00b41390-63d5-466e-b9a4-a270b9f5f16d", //dev
    label: "Ganesh Kamble",
  },
  "sindhu@tatva.health": {
    // value: "eb4012d2-408b-4e22-b979-4c5af9dc2aab", // prod
    value: "4d2b3116-81f8-4901-8a63-144e154b051f", //dev
    label: "Sindhu",
  },
  "patilgaurang@traya.health": {
    // value: "1105394b-d5b8-459f-b5bd-721a77cc3a1c", // prod
    value: "00af1fe6-1242-42c0-9192-998f09c5bee0", //dev
    label: "Gaurang",
  },
  "deyashish@traya.health": {
    // value: "1c911188-5dcd-404e-9f28-b38213491796", // prod
    value: "4d2b3116-81f8-4901-8a63-144e154b051f", //dev
    label: "Ashish",
  },
  "yadavpratibha@traya.health": {
    // value: "873ed717-13d0-45b6-80dc-d572dffb0be2", // prod
    value: "01606e96-fc51-480c-8542-1040528a82dc", //dev
    label: "Pratibha",
  },
  "mitraparth@traya.health": {
    // value: "d8c044ee-e3fc-4519-a12f-94ec87a56124", // prod
    value: "4d2b3116-81f8-4901-8a63-144e154b051f", //dev
    label: "Parth",
  },
  "choudharyphilona@traya.health": {
    value: "3b311a50-7606-4524-b711-a4888c3143b2", // prod
    // value: "4d2b3116-81f8-4901-8a63-144e154b051f", //dev
    label: "Philona Choudhary",
  },
  "kripapurohit@tatvarthahealth.com": {
    // value: "prod-placeholder", // prod
    value: "8ded31fb-efc7-40b3-9c8c-ef6ba6997010", //dev
    label: "Kripa Purohit",
  },
  "sangeetagupta@tatvarthahealth.com": {
    // value: "prod-placeholder", // prod
    value: "f5d85e32-64af-4c49-a2c9-059464398a02", //dev
    label: "Sangeeta Gupta",
  },
  "khanahad@tatvarthahealth.com": {
    // value: "prod-placeholder", // prod
    value: "eca2ddd7-8ddd-4c87-8c61-a8f89bf85b03", //dev
    label: "Khan Ahmad",
  },
  "shahrehan@tatvarthahealth.com": {
    // value: "prod-placeholder", // prod
    value: "9dff74aa-34d3-4877-a268-3361ffcb1b0e", //dev
    label: "Rehan Shah",
  },
  "faizansari@tatvarthahealth.com": {
    // value: "prod-placeholder", // prod
    value: "429530e4-3e21-4860-99f7-3faec709cedc", //dev
    label: "Faiz Ansari",
  },
};


export const techTeamMember = {
  "agarwalsandip@traya.health": {
    // value: "4f9f70c7-f4e1-466e-a387-01d359fd9b93", //prod
    value: "4d2b3116-81f8-4901-8a63-144e154b051f", //dev
    label: "Sandip Agarwal",
  },
};

export const escalationTeamMember = {
  "priyankakanojia@traya.health": {
    // value: "3d095db2-c84a-4d27-9e2c-c3b37d7793ab", // prod
    value: "00f941d7-8c24-4e8d-a60c-8f0432378ec6", //dev
    label: "Priyanka kanojia",
  },
  "khanmahenaaz@traya.health": {
    // value: "fbbdd445-3df2-48ee-8726-4e96856ce78c", // prod
    value: "4d2b3116-81f8-4901-8a63-144e154b051f", //dev
    label: "Khan Mahenaaz",
  },
  "siddhi@tatva.health": {
    // value: "8906e2cb-11c6-4f8b-8def-54d7c40deeab",  // prod
    value: "4d2b3116-81f8-4901-8a63-144e154b051f", //dev
    label: "Siddhi",
  },
  "kalyani@tatva.health": {
    // value: "1c290664-1ea9-43bc-81f1-554d26eee917", // prod
    value: "4d2b3116-81f8-4901-8a63-144e154b051f", //dev
    label: "Kalyani",
  },
  "harish@traya.health": {
    // value: "c5fc686a-8f31-4419-8151-fd8e5c1ee7ee", // prod
    value: "4d2b3116-81f8-4901-8a63-144e154b051f", //dev
    label: "Harish",
  },
  "shefali@tatva.health": {
    // value: "51e339f9-4d49-4af1-9c0d-f5662e43c1d1", // prod
    value: "4d2b3116-81f8-4901-8a63-144e154b051f", //dev
    label: "Shefali",
  },
};

